import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"

// Dev environment
// var firebaseConfig = {
//   apiKey: "AIzaSyAhPY4nR5tDanQbIHmP3MLrgNHDka2shns",
//   authDomain: "agenz-dev.firebaseapp.com",
//   projectId: "agenz-dev",
//   storageBucket: "agenz-dev.appspot.com",
//   messagingSenderId: "459123777464",
//   appId: "1:459123777464:web:98b6ad0c1d53adaac3f94d"
// };

// Prod environment

import { firebaseConfig } from './FIREBASE_CONFIG'

//Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
firebase.auth();

// console.log(analytics)

export default firebase;